import { render, staticRenderFns } from "./PanelText.vue?vue&type=template&id=280e35cf&scoped=true&"
import script from "./PanelText.vue?vue&type=script&lang=js&"
export * from "./PanelText.vue?vue&type=script&lang=js&"
import style0 from "./PanelText.vue?vue&type=style&index=0&id=280e35cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e35cf",
  null
  
)

component.options.__file = "PanelText.vue"
export default component.exports